import adcampaign from "./adcampaign.png";
import amazon from "./amazon.png";
import googleAnalyticsServices from "./googleAnalyticsServices.png";
import influencer from "./influencer.png";
import network from "./network.png";
import paidMarketing from "./paidMarketing.png";
import seo from "./seo.png";
import smo from "./smo.png";
import whiteLabelService from "./whiteLabelService.png";
import leftMenuBg from "./leftMenuBg.png";
import close from "./close.png";

export const header = {
  adcampaign,
  amazon,
  googleAnalyticsServices,
  influencer,
  network,
  paidMarketing,
  seo,
  smo,
  whiteLabelService,
  leftMenuBg,
  close,
};
